
export const LSTORAGE_KEY = {
    CONTENTS_LIKE: 'contents.like',
    TTS_VOICE: 'tts.voice',
    SELECT_REGION: 'select.region',
    LATEST_READ: 'LATEST_READ',
    TOGGLE_NEXT: 'TOGGLE_NEXT',

    //redux
    REDUX_CONTENT: 'redux.content',

    BM_UID: "bm_uid"
};

export const SESSION_KEY = {
    ZSID: 'za_bm_sid',
    CLOSE_SLIDER_FOOTER: 'close.download',
};

export const COOKIE_KEY = {
    BM_GY: '_bm_gy',
    BM_SEGMENTS: '_bm_segments',
    BM_CONTENT_READ: process.env.APP_ENV === 'production' ? '_live3_bm_contents_read' : '_dev2_bm_contents_read',
    BM_TIME_CONTENT_READ: process.env.APP_ENV === 'production' ? '_live3_bm_times_content_read' : '_dev2_bm_times_content_read',
    BM_CLICK_LOGIN: '_bm_click_login'
};
